import { createFileRoute } from '@tanstack/react-router';

import { MobileAppRedirect } from 'src/apps/landingPages/app/pages/MobileAppRedirect';

export const Route = createFileRoute('/_public/downloads/mobile-app')({
  component: () => <MobileAppRedirect />,
});
